import { UserRole } from '@/types/User'

export interface UserContext_User {
  agent: UserContext_Agent | null
  auth_token: string
  email: string
  fullName: string
  homeBlockPermitted: boolean
  id: number
  isAgm: boolean
  isBilling: boolean
  isHubManager: boolean
  isSuperAdmin: boolean
  isXteam: boolean
  marketSegmentIds: number[] | null
  role: UserRole
}

export interface UserContext_Agent {
  id: number | null
  role: AgentRoles | null
}

export enum AgentRoles {
  AGENT = 'Agent',
  SUPERVISOR = 'Supervisor',
}

export interface UserContext_State {
  isAdmin: boolean
  isLoading: boolean
  isLoggedIn: boolean
  user: UserContext_User | null
}

export interface UserContext_Type extends UserContext_State {
  logoutUser: () => void
  refreshToken: (token: string) => void
  setLoading: (val: boolean) => void
  updateUser: (_body: UserContext_User) => void
}
